import { Phone, MapPin, Instagram, MessageCircle } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { waLink } from "@/lib/api";
import { Reveal } from "@/components/store/Reveal";

export default function Contact() {
  const { settings } = useStore();

  return (
    <div className="pt-28 md:pt-36 pb-24" data-testid="contact-page">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid md:grid-cols-2 gap-14">
        <div>
          <Reveal>
            <p className="overline text-terracotta mb-3">Get in touch</p>
            <h1 className="font-serif text-5xl md:text-7xl text-espresso tracking-tight mb-6">Let&apos;s talk skin</h1>
            <p className="text-bark text-lg leading-relaxed mb-10 max-w-md">
              Have a question about your skin or an order? Chat with us directly on WhatsApp — we love helping our
              community glow.
            </p>
          </Reveal>

          <Reveal delay={0.15}>
            <a
              href={waLink(settings.whatsapp, "Hi 17/11 BeautyBarn! I have a question.")}
              target="_blank"
              rel="noreferrer"
              data-testid="contact-whatsapp"
              className="inline-flex items-center gap-3 bg-[#25D366] text-white px-7 py-4 rounded-full font-medium hover:opacity-90 transition-opacity mb-10"
            >
              <MessageCircle className="w-5 h-5" /> Chat on WhatsApp
            </a>
          </Reveal>

          <div className="space-y-5">
            <Reveal delay={0.2}>
              <a href={`tel:${settings.phone}`} className="flex items-center gap-4 group" data-testid="contact-phone">
                <span className="w-11 h-11 rounded-full bg-sand flex items-center justify-center text-terracotta"><Phone className="w-5 h-5" /></span>
                <div>
                  <p className="overline text-bark">Call us</p>
                  <p className="text-espresso group-hover:text-terracotta transition-colors">{settings.phone}</p>
                </div>
              </a>
            </Reveal>
            <Reveal delay={0.25}>
              <a href={settings.instagram || "#"} target="_blank" rel="noreferrer" className="flex items-center gap-4 group" data-testid="contact-instagram">
                <span className="w-11 h-11 rounded-full bg-sand flex items-center justify-center text-terracotta"><Instagram className="w-5 h-5" /></span>
                <div>
                  <p className="overline text-bark">Instagram</p>
                  <p className="text-espresso group-hover:text-terracotta transition-colors">@elohoboma</p>
                </div>
              </a>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="flex items-center gap-4">
                <span className="w-11 h-11 rounded-full bg-sand flex items-center justify-center text-terracotta"><MapPin className="w-5 h-5" /></span>
                <div>
                  <p className="overline text-bark">Location</p>
                  <p className="text-espresso">{settings.location}</p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1}>
          <div className="rounded-[2rem] overflow-hidden h-full min-h-[400px] border border-sandline">
            <iframe
              title="Port Harcourt location"
              src="https://www.google.com/maps?q=Port%20Harcourt%2C%20Nigeria&output=embed"
              className="w-full h-full"
              style={{ border: 0, minHeight: 400 }}
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
